/**
 * THE sentiment-scan age limit, shared by every sentiment age gate
 * (owner decision 1, 2026-09-30: "can't it just use the SED we have if it is
 * recent?"). Dependency-free so browser, server and job bundles can all import
 * it without pulling the collector or the orchestrator.
 *
 * A dated scan up to this old is an admissible screening basis. Every report
 * states the scan's own collection date ("records actually read as of …",
 * "Collection date: …"), so a reused scan is never presented as today's read.
 *
 * Consumers (all derive from these constants, none restates a number):
 *  - generation / screening readiness and the frozen-receipt validators
 *    (`publicSentimentScreeningReadiness`), which the enqueue, the report
 *    generator, build seeding (bootstrapSiteSedServer) and the coverage probes
 *    call;
 *  - the canonical server collector's reuse decision
 *    (`publicSentimentIsCurrent`: builds reuse up to the limit, a Public
 *    Sentiment report up to the limit minus the job margin below);
 *  - the browser top-up and its `pse-cache` window (services/sedBootstrap);
 *  - the SED section staleness TTL (`SED_SECTION_TTL_DAYS.publicSentiment`).
 */
export const PUBLIC_SENTIMENT_SCAN_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Margin a REUSED scan keeps below the limit. A report job may run for up to
 * its 70-minute deadline (JOB_DEADLINE_MS in executeReportGenerationJob.ts)
 * after admission and re-checks screening readiness during generation, so a
 * scan reused right at the limit could cross it mid-run and fail the job.
 * Two hours covers the deadline with slack for queueing.
 */
export const PUBLIC_SENTIMENT_REUSE_MARGIN_MS = 2 * 60 * 60 * 1000;

/** Oldest scan a Public Sentiment report reuses instead of rescanning. */
export const PUBLIC_SENTIMENT_REUSE_MAX_AGE_MS =
  PUBLIC_SENTIMENT_SCAN_MAX_AGE_MS - PUBLIC_SENTIMENT_REUSE_MARGIN_MS;

/** The same limit in whole days, for day-granular staleness tables. */
export const PUBLIC_SENTIMENT_SCAN_MAX_AGE_DAYS = PUBLIC_SENTIMENT_SCAN_MAX_AGE_MS / (24 * 60 * 60 * 1000);
